import { CalendarIcon, ClockIcon } from '@heroicons/react/24/outline';
import { calculateRagStatus, formatDateTime, formatDateTimeShort } from '../../utils/date-utils';
import './DueDate.css';
import { HTMLAttributes, useContext, useState } from 'react';
import { AppContext } from '../../App';
import Modal from '../modal/Modal';
import Input from '../input/Input';

interface Props {
  date?: Date | string;
  style?: HTMLAttributes<HTMLSpanElement>['style'];
  title?: string;
  onSetDueDate?: (newDueDate: Date) => Promise<void> | void;
}

const DueDate: React.FC<Props> = ({ date, style, title, onSetDueDate }) => {
  const ctx = useContext(AppContext);
  const [showSetDateModal, setShowSetDateModal] = useState(false);
  const dateToDisplay = formatDateTimeShort(date || new Date(), ctx.user.company.locale, ctx.user.company.timezone);
  const rag = calculateRagStatus(date || new Date());
  const dateForTitle = formatDateTime(date || new Date(), ctx.user.company.locale, ctx.user.company.timezone);

  const [dateString, timeString] = dateToDisplay.split(' ');
  return (
    <div>
      {!!onSetDueDate && !showSetDateModal && (
        <button className="link-button due-date__set-button" onClick={() => setShowSetDateModal(true)}>
          <CalendarIcon /> Update
        </button>
      )}
      {!!date && (
        <span style={style} title={`${title} | ${dateForTitle}`} className={`due-date due-date--${rag}`}>
          <div className="due-date__date">
            <CalendarIcon />
            {dateString}
          </div>
          <div className="due-date__time">
            <ClockIcon />
            {timeString}
          </div>
        </span>
      )}
      {!!showSetDateModal && (
        <Input
          value={date ? new Date(date).toISOString() : ''}
          onChange={async (value) => {
            if (onSetDueDate) {
              await onSetDueDate(new Date(value));
              setShowSetDateModal(false);
            }
          }}
          labelText="Set due date"
          id="due-date"
          type="date"
          small={true}
        />
      )}
    </div>
  );
};

export default DueDate;
